export enum Scene {
    LandingPage,
    MainPage,
    Lobby,
    Room,
    Game,
    DiscordLeaderboard,
    DiscordStore,
    DiscordAbout,
    DiscordCareers,
    DiscordCommunity,
    DiscordFAQ,
    DiscordPrivacyPolicy,
    DiscordPatchNotes,
    DiscordProfile,
    DiscordGifting,
    DiscordValues,
    DiscordTerms,
    DiscordPressKit,
    DiscordRefundPolicy,
    DiscordReplay
}
